import React from "react";
import { AuthButton } from "./AuthLayout";
import { FaCheck } from "react-icons/fa";

export function SuccessView({ title, message, onContinue, buttonText = "Continue" }: { title: string, message: string, onContinue: () => void, buttonText?: string }) {
    return (
        <div className="w-full flex flex-col items-center text-center">
            <div className="w-24 h-24 bg-[#008000] rounded-full flex items-center justify-center mb-6 relative">
                {/* Creating the jagged/flower edge effect is hard with pure CSS shapes or tailwind without SVGs. 
              The image shows a green seal-like shape. 
              For simplicity, I will use a circle with a checkmark or try to replicate the seal with an SVG if needed.
              Let's use a simple circle for now, or a star shape if possible. 
          */}
                <div className="absolute inset-0 rounded-full border-[6px] border-[#008000] border-dashed animate-spin-slow opacity-20"></div>
                <FaCheck className="text-white text-5xl" />
            </div>

            <h1 className="text-3xl font-bold text-[#338585] mb-4">{title}</h1>
            <p className="text-gray-500 mb-12 max-w-xs leading-relaxed">
                {message}
            </p>

            <AuthButton onClick={onContinue}>
                {buttonText}
            </AuthButton>
        </div>
    );
}
